import { useQuery, gql } from '@apollo/client'
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import slugify from 'slugify'
import { getCustomNoOptionText } from 'components/CountrySearchLegacy'
import { Select } from 'components/Select'

export const CITIES_QUERY = gql`
  query cities($input: AutocompleteInput!) {
    cities(input: $input) {
      title
    }
  }
`

export const CitySearchLegacy = ({
  value,
  onChange,
  isError,
  hint,
  countryIsoCode,
  isDisabled,
  isRequiredField = false,
  ...rest
}) => {
  const [inputValue, setInputValue] = useState(value.title)
  const [selectedValue, setSelectedValue] = useState(value)
  const cityQuery = useQuery(CITIES_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        countryIsoCode,
        search: slugify(inputValue || ''),
      },
    },
  })

  useEffect(() => {
    setInputValue(value.title)
    setSelectedValue(value)
  }, [value])

  const cities = cityQuery?.data?.cities || []
  const customNoOptionsText = getCustomNoOptionText({
    inputValue,
    isLoading: cityQuery.loading,
    options: cities,
    label: 'city',
  })
  return (
    <Select
      isDisabled={!countryIsoCode || isDisabled}
      hasHint
      label={isRequiredField ? 'City*' : 'City'}
      autocomplete={false}
      isError={isError}
      hint={hint}
      isSearchable
      value={selectedValue}
      getOptionLabel={(item) => item.title}
      getOptionValue={(item) => item.title}
      customNoOptionsText={customNoOptionsText}
      options={cities}
      onInputChange={setInputValue}
      onChange={({ title }) => {
        const newValue = {
          title,
          value: title,
        }
        onChange(newValue)
        setSelectedValue(newValue)
      }}
      {...rest}
    />
  )
}

CitySearchLegacy.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  isError: PropTypes.bool,
  hint: PropTypes.string,
  countryIsoCode: PropTypes.string,
  isDisabled: PropTypes.bool,
  isRequiredField: PropTypes.bool,
}
